<template>
  <div class="content">
    <el-menu
      active-text-color="hsla(0, 0%, 100%, 0.95)"
      background-color="#21252b"
      text-color="hsla(0, 0%, 100%, 0.95)"
      :default-active="activeIndex"
      :collapse="isCollapse"
      unique-opened
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
    >
      <div class="user-box">
        <img class="avatar" src="../../../assets/vue.png" alt="" />
        <span class="name" v-if="!isCollapse">leling classroom</span>
      </div>
      <div v-for="(item, index) in menuList" :key="index">
        <el-submenu
          v-if="item.children && item.children.length > 0"
          :index="String(item.id)"
        >
          <template slot="title">
            <i class="el-icon-location" style="color: #fff"></i>
            <span>{{ item.title }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item
              v-for="(items, indexs) in item.children"
              @click="routerBtn(items)"
              :key="indexs"
              :index="items.path"
              >{{ items.title }}</el-menu-item
            >
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item
          v-else
          :key="index"
          :index="item.path"
          @click="routerBtn(item)"
        >
          <i class="el-icon-menu" style="color: #fff"></i>
          <span slot="title">{{ item.title }}</span>
        </el-menu-item>
      </div>
    </el-menu>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      activeIndex: "",
      isCollapse: this.$store.state.app.isCollapse,
      menuList: [],
    };
  },
  created() {
    this.$store.watch(
      (state, getters) => {
        return state.app.isCollapse;
      },
      () => {
        this.isCollapse = this.$store.state.app.isCollapse;
      }
    );
  },
  mounted() {
    // setTimeout(() => {
    let data = JSON.parse(localStorage.getItem("menuList"));
    this.menuList = data;
    // data.forEach((item) => {
    //   if (
    //     item.title != "通用信息" &&
    //     item.title != "课时制" &&
    //     item.title != "学期制"
    //   ) {
    //     this.menuList.push(item);
    //   }
    //   if (item.title == "通用信息") {
    //     this.generalList = item.children;
    //   }
    //   if (item.title == "课时制") {
    //     this.hourList = item.children;
    //   }
    //   if (item.title == "学期制") {
    //     this.semesterList = item.children;
    //   }
    // });
    // }, 1500);
    this.activeIndex = this.$route.path;
    this.isCollapse = this.$store.state.app.isCollapse;
  },
  methods: {
    routerBtn(e) {
      this.$router.push(e.path);
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>

<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 256px;
  min-height: 100vh;
  /* min-height: 400px; */
}
html body .el-submenu__title i {
  color: #fff;
}
</style>
<style scoped lang='scss'>
.content {
  // width: 256px;
  // z-index: 1000;
  // min-height: 100vh;
  // background: #21252b;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 10000;
  // width: 256px;
  min-height: 100vh;
  // overflow: hidden;
  background: #21252b;
  // box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
  transition: width 0.3s;
  overflow-y: auto;

  .user-box {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
    .avatar {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      margin-right: 3px;
    }
    .name {
      display: inline-block;
      overflow: hidden;
      font-size: 24px;
      line-height: 55px;
      color: #fff;
      text-overflow: ellipsis;
      white-space: nowrap;
      vertical-align: middle;
      max-width: calc(256px - 60px);
    }
  }
  .el-menu {
    height: 100%;
  }

  .el-menu-item.is-active {
    color: rgba(255, 255, 255, 0.95);
    background-color: #409eff !important;
  }
  .el-menu-item:hover {
    color: rgba(255, 255, 255, 0.95);
    background-color: #409eff !important;
  }

  .el-submenu__title i {
    color: #fff !important;
  }

  .el-icon-arrow-down:before {
    color: #fff !important;
  }
  /*隐藏文字*/
  .el-menu--collapse .el-submenu__title span {
    display: none;
  }
  /*隐藏 > */
  .el-menu--collapse .el-submenu__title .el-submenu__icon-arrow {
    display: none;
  }
}
</style>
